<template>
	<div class="c-play-pause">
		<DsText class="c-play-pause__pagination" text-type="body-xs"
			>{{ currentItem }}/{{ totalItems }}</DsText
		>
		<DsButtonPlayProgress
			:aria-label-pause="ariaLabelPause"
			:aria-label-play="ariaLabelPlay"
			:play-handler="play"
			:pause-handler="pause"
			:progress="progress"
			size="responsive"
			variant="on-light"
			ref="playPauseButton"
		></DsButtonPlayProgress>
	</div>
</template>

<script setup lang="ts">
import { DsButtonPlayProgress, DsText } from '@coloplast/design-system';
import '@coloplast/design-system/dist/components/button/ds-button-play-progress.css';
import { onMounted, toRef, useTemplateRef, watch } from 'vue';

export type PlayPauseIndicatorProps = {
	ariaLabelPause?: string;
	ariaLabelPlay?: string;
	currentItem: number;
	totalItems: number;
	progress: number;
	play: () => void;
	pause: () => void;
	isPlaying: boolean;
};

type DsButtonPlayProgressType = InstanceType<typeof DsButtonPlayProgress>;

const props = withDefaults(defineProps<PlayPauseIndicatorProps>(), {
	ariaLabelPause: "Pause",
	ariaLabelPlay: "Play",
	progress: 0,
	isPlaying: false,
});

const isPlaying = toRef(props, 'isPlaying');

const playPauseButton =
	useTemplateRef<DsButtonPlayProgressType>('playPauseButton');

onMounted(() => {
	playPauseButton.value?.setButtonState(props.isPlaying);
});

watch(isPlaying, (newVal) => {
	playPauseButton.value?.setButtonState(newVal);
});
</script>

<style lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-play-pause {
	align-items: center;
	border-radius: 999px;
	background: ds-color(bg, default);
	display: flex;
	flex-shrink: 1;
	gap: ds-gap(3);
	justify-self: self-start;
	padding: ds-space(2) ds-space(2) ds-space(2) ds-space(5);

	&__pagination {
		font-variant-numeric: tabular-nums;
		margin: 2px 0 0 0;
	}
}
</style>
